import {
  COVER_SELECTION_HELP_TOOLTIP,
  PROFILE_SELECTION_HELP_TOOLTIP,
  MEDIA_CATEGORY_COVER,
  MEDIA_CATEGORY_PROFILE,
} from '../../constants/media';

export const ASPECT_RATIO_BY_ASSOCIATION = {
  [MEDIA_CATEGORY_PROFILE]: '1 / 1',
  [MEDIA_CATEGORY_COVER]: '16 / 9',
};

export const HELP_TEXT_BY_ASSOCIATION = {
  [MEDIA_CATEGORY_PROFILE]: PROFILE_SELECTION_HELP_TOOLTIP,
  [MEDIA_CATEGORY_COVER]: COVER_SELECTION_HELP_TOOLTIP,
};
